import cn from 'classnames/bind';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './styles.styl';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { Button } from '@consta/uikit/Button';
import { IconBackward } from '@consta/uikit/IconBackward';
import {
  IFiles,
  IVersionType,
} from 'src/redux/features/methodModels/allModels/types';
import { formatDate } from 'src/utils';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { InitTypeModalEnum } from 'src/utils/enum';
import { heightTextViewModel } from 'src/utils/config';
import { loadRunModels } from 'src/redux/features/methodModels/runModels/actions';
import { useDispatch } from 'react-redux';

const cx = cn.bind(styles);

export interface IViewModalProps {
  setIsViewModal: (item: boolean) => void;
  setIsRunningModal: (item: boolean) => void;
  className?: string;
  id: string;
  title: string;
  text: string;
  version: IVersionType[];
  image: IFiles[];
  type: number;
  url: string;
  manual: string;
}

const ViewModal: React.FC<IViewModalProps> = ({
  className,
  setIsViewModal,
  setIsRunningModal,
  id,
  title,
  text,
  version,
  image,
  type,
  url,
  manual,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const dispatch = useDispatch();

  const ref = useRef([]);

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const [isOpenVersion, setIsOpenVersion] = useState(
    new Array(version.length).fill(false),
  );

  const [textRef, setTextRef] = useState(ref);
  const [isClamp, setIsClamp] = useState([]);

  useEffect(() => {
    if (textRef.current) {
      textRef.current.map((item, index) => {
        if (item.offsetHeight > heightTextViewModel.dekstop && !isMobile) {
          const newClamp = [...isClamp];
          newClamp[index] = true;
          setIsClamp(newClamp);
        } else if (item.offsetHeight > heightTextViewModel.mobile && isMobile) {
          const newClamp = [...isClamp];
          newClamp[index] = true;
          setIsClamp(newClamp);
        }
      });
    }
  }, [isClamp, isMobile, textRef]);

  const handleRunning = useCallback(() => {
    if (type !== InitTypeModalEnum.ANY_LOGIC) {
      window.open(url);
      dispatch(loadRunModels(id));
    } else {
      setIsRunningModal(true);
      setIsViewModal(false);
    }
  }, [setIsRunningModal, setIsViewModal, type, url]);

  const handleOpenVersion = useCallback((index: number, data: boolean) => {
    setIsOpenVersion((prev) => {
      return prev.map((item, i) => {
        return i === index ? !data : item;
      });
    });
  }, []);

  return (
    <div className={cx('ViewModal', className)}>
      <div className={cx('ViewModal__title')}>
        {isMobile && (
          <Button
            className={cx('ViewModal__buttonCloseMobile')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconBackward}
            onClick={() => setIsViewModal(false)}
          />
        )}
        <Text weight="semibold">{title}</Text>
        {!isMobile && (
          <Button
            className={cx('ViewModal__buttonClose')}
            iconSize="s"
            view="clear"
            onlyIcon
            iconLeft={IconClose}
            onClick={() => setIsViewModal(false)}
          />
        )}
      </div>
      <div className={cx('ViewModal__container')}>
        <div className={cx('ViewModal__descriptionContent')}>
          <div>
            <Text
              size="s"
              className={cx('ViewModal__description')}
              view="secondary"
            >
              Описание
            </Text>
            <Text
              size="s"
              lineHeight="l"
              view={text ? 'primary' : 'ghost'}
              className={cx('ViewModal__descriptionText', {
                ViewModal__descriptionText_passiveManual: !text,
              })}
            >
              {text || 'Описание отстутствует'}
            </Text>
          </div>
          <div
            className={cx('ViewModal__imageContainer', {
              ViewModal__imageContainer_bgr: !image.length,
            })}
          >
            {!!image.length && (
              <img
                className={cx('ViewModal__image')}
                src={`${process.env.REACT_APP_STATIC_URL}/${image[0].path}`}
              />
            )}
          </div>
        </div>
        <div>
          <Text
            size="s"
            className={cx('ViewModal__description')}
            view="secondary"
          >
            Инструкция по использованию
          </Text>
          <Text
            size="s"
            lineHeight="l"
            view={manual ? 'primary' : 'ghost'}
            className={cx('ViewModal__descriptionText', {
              ViewModal__descriptionText_passiveInstruction: !manual,
            })}
          >
            {manual || 'Инструкция отстутствует'}
          </Text>
        </div>
        {!!version.length && (
          <Text weight="semibold" className={cx('ViewModal__history')}>
            История версий
          </Text>
        )}
        {version.map((item, index) => (
          <div className={cx('ViewModal__version')} key={item.id}>
            <div className={cx('ViewModal__versionTitleContent')}>
              <Text size="s">{item.version}</Text>
              <div>
                <Text
                  className={cx('ViewModal__versionDateUpdate')}
                  display="inlineBlock"
                  size="s"
                  view="secondary"
                >
                  Дата обновления:{' '}
                </Text>
                <Text display="inlineBlock" size="s">
                  {formatDate(item.updated_at)}
                </Text>
              </div>
            </div>
            <div className={cx('ViewModal__content')}>
              <div
                className={cx('ViewModal__containerText', {
                  ViewModal__containerText_active: isOpenVersion[index],
                  ViewModal__containerText_clamp: isClamp[index],
                })}
                ref={(el: HTMLDivElement) => {
                  setTextRef((prev) => {
                    prev.current[index] = el;
                    return prev;
                  });
                }}
              >
                <Text
                  size="s"
                  view="secondary"
                  className={cx('ViewModal__text')}
                >
                  {item.description}
                </Text>
              </div>
              {isClamp[index] && (
                <div className={cx('ViewModal__arrowDown')}>
                  <IconArrowDown
                    className={cx('ViewModal__arrowText', {
                      ViewModal__arrowText_active: isOpenVersion[index],
                    })}
                    onClick={() =>
                      handleOpenVersion(index, isOpenVersion[index])
                    }
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className={cx('ViewModal__save')}>
        <Button
          onClick={() => {
            setIsViewModal(false);
          }}
          label="Закрыть"
          size="s"
          view="ghost"
          className={cx('ViewModal__buttonExit')}
        />
        <Button
          onClick={handleRunning}
          size="s"
          label={'Запустить'}
          className={cx('ViewModal__buttonRun')}
        />
      </div>
    </div>
  );
};

export default ViewModal;
